import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";

// 1. Definimos la animación de Fade In (aparecer suavemente)
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px); // Empieza un poco más abajo
  }
  to {
    opacity: 1;
    transform: translateY(0); // Sube a su posición final
  }
`;

// 2. Definimos la animación de Fade Out (desaparecer suavemente)
const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px); // Baja al desaparecer
  }
`;

// 3. Estilos del contenedor del botón (fixed)
const ButtonContainer = styled.div`
  position: fixed;
  bottom: 40px;
  left: 40px; // Posicionado a la derecha
  z-index: 999;
  cursor: pointer;

  // Control de la animación
  opacity: 0; // Oculto por defecto
  visibility: hidden; // Y no interactuable
  transition: visibility 0.4s; // Asegura que la visibilidad espere a la animación

  // Clase que aplicaremos cuando deba ser visible
  &.visible {
    visibility: visible;
    animation: ${fadeIn} 0.6s ease-out forwards;
  }

  // Clase que aplicaremos cuando deba ocultarse
  &.hidden {
    animation: ${fadeOut} 0.4s ease-out forwards;
    // La visibilidad se oculta *después* de que la animación termina (gracias a transition)
  }
`;

// 4. Estilos del icono (tu CSS original ajustado)
const Icon = styled.i`
  font-size: 32px;
  color: gray;
  transition: all 0.3s ease; // Para el hover

  &:hover {
    color: #131111;
    transform: scale(1.1); // Pequeño efecto de zoom
  }
`;

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Muestra el botón si bajamos más de 400px
      if (window.scrollY > 400) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    
    // Limpieza del evento
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Scroll suave
    });
  };

  return (
    // Aplicamos la clase "visible" o "hidden" según el estado
    <ButtonContainer 
        className={showButton ? "visible" : "hidden"} 
        onClick={scrollToTop}
        aria-label="Volver arriba"
    >
      {/* CORRECCIÓN: Usamos el icono una sola vez aquí */}
      <Icon className="fas fa-chevron-up"></Icon>
    </ButtonContainer>
  );
};

export default ScrollToTop;